import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiListComponent } from './ui-list/ui-list.component';
import { UiListItemComponent } from './ui-list-item/ui-list-item.component';

@NgModule({
  declarations: [UiListComponent, UiListItemComponent],
  imports: [CommonModule],
  exports: [UiListComponent, UiListItemComponent],
})
export class UiListModule {}
